import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ApiProvider } from '@reduxjs/toolkit/query/react';
import App from './App';
// import {store} from './redux/store';
import { apiSlice } from './redux/apiSlice';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ApiProvider api={apiSlice}>
      <App />
    </ApiProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
